import plans from '../plans/payment-status';
import moment from 'moment';

const CurrentPlan = ({ paymentStatus, endDate, subscriptionDetails }) => {
	let plan;
	if (!paymentStatus || paymentStatus === null) {
		plan = plans[9].label;
	}
	if (plans && plans[parseInt(paymentStatus)]) {
		plan = plans[parseInt(paymentStatus)].label;
	}
	let endData = endDate ? moment(endDate).format('LL') : '';

	const formatPrice = (cost, currency) => {
		if (!cost || !currency) return 'N/A';
		const currencySymbol = currency === 'USD' ? '$' : currency;
		return `${currencySymbol}${cost}`;
	};

	const formatFrequency = (frequency) => {
		return frequency ? frequency.toLowerCase() : 'month';
	};

	const hasSubscriptionDetails =
		subscriptionDetails && typeof subscriptionDetails === 'object';

	const isTrialPlan =
		!paymentStatus ||
		paymentStatus === null ||
		parseInt(paymentStatus) === 9 ||
		paymentStatus === '9';

	return (
		<div className="mb-12">
			<h2 className="text-xl font-semibold text-gray-800 mb-2">
				Current subscription details
			</h2>
			<div className="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-xl p-6 shadow-sm">
				<div className="flex items-start justify-between mb-4">
					<div>
						<h5 className="font-bold text-gray-900 text-2xl mb-1">
							{isTrialPlan
								? plan
								: hasSubscriptionDetails && subscriptionDetails.planName
								? subscriptionDetails.planName
								: plan}
						</h5>
						{hasSubscriptionDetails && subscriptionDetails.trialDays > 0 && (
							<span className="inline-block bg-green-100 text-green-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">
								{subscriptionDetails.trialDays} days trial
							</span>
						)}
					</div>
					{!isTrialPlan &&
						hasSubscriptionDetails &&
						subscriptionDetails.recurringCost && (
							<div className="text-right">
								<div className="text-3xl font-bold text-purple-700">
									{formatPrice(
										subscriptionDetails.recurringCost,
										subscriptionDetails.currency
									)}
								</div>
								<div className="text-sm text-gray-600">
									per {formatFrequency(subscriptionDetails.frequency)}
								</div>
							</div>
						)}
				</div>

				<div className="border-t border-purple-200 pt-4 mt-4">
					<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
						{endData && (
							<div className="flex items-center">
								<div className="flex-shrink-0 w-10 h-10 bg-purple-200 rounded-full flex items-center justify-center">
									<svg
										className="w-5 h-5 text-purple-700"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
										/>
									</svg>
								</div>
								<div className="ml-3">
									<p className="text-xs text-gray-500">Next payment</p>
									<p className="text-sm font-semibold text-gray-800">
										{endData}
									</p>
								</div>
							</div>
						)}

						{!isTrialPlan &&
							hasSubscriptionDetails &&
							subscriptionDetails.frequency && (
								<div className="flex items-center">
									<div className="flex-shrink-0 w-10 h-10 bg-purple-200 rounded-full flex items-center justify-center">
										<svg
											className="w-5 h-5 text-purple-700"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
										>
											<path
												strokeLinecap="round"
												strokeLinejoin="round"
												strokeWidth={2}
												d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
											/>
										</svg>
									</div>
									<div className="ml-3">
										<p className="text-xs text-gray-500">Billing cycle</p>
										<p className="text-sm font-semibold text-gray-800 capitalize">
											{formatFrequency(subscriptionDetails.frequency)}ly
										</p>
									</div>
								</div>
							)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default CurrentPlan;
